module.exports = __webpack_public_path__ + "static/media/hudson_alberto.91986d1f.png";